import { Dialog } from "@mui/material";

export const COLOR = {
  white: "#FFFFFF",
  black: "#000000",
  danger: "#FF1943",
  success: "#70d082",
  lightGreen: "#ccff90",
  accept: "rgb(238,250,232)",
  decline: "rgb(255,232,236)",
  awaiting: "rgb(234,249,255)",
  info: "rgb(255,246,235)",
  inputColor: "#000",
  light: "#666666",
  btnBg1: "#f9dc72",
  tabBg1: "#937506",
  btnBg2: "#E39756",
  CU_signup_card1: "#f9dc72",
  CU_signup_card2: "#E39756",
  CU_dashboard_bg: "#DFE5EB",
  NV_User_color: "rgb(127,127,132)",
  grey: "grey",
  blue: "blue",
  LSColor: "#1C1E21",
  LSbgColor: "rgb(227,151,86)",
  DialogBg: "#F0F0F0",
  textColor: "#1A1B23",
  stepperBg: "#f5f5f5",
  StepBtn: "#e0e1e8",
  ToggleActive: "#F9DB6C",
  subtitle: "#3E3B42",
  subValue: "#4D515D",
  btnBg3: "#937506",
  dltIcon: "#AF251D",
};

export const FONTWEIGHT = {
  fw_100: 100,
  fw_200: 200,
  fw_300: 300,
  fw_400: 400,
  fw_500: 500,
  fw_600: 600,
  fw_700: 700,
  fw_800: 800,
  fw_900: 900,
};

export const FONTSIZE = {
  fs_10: 10,
  fs_11: 11,
  fs_12: 12,
  fs_14: 14,
  fs_16: 16,
  fs_18: 18,
  fs_20: 20,
  fs_22: 22,
  fs_24: 24,
  fs_26: 26,
  fs_28: 28,
  fs_30: 30,
};

export const BOXSHADOW = {
  userCard:
    "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
  templateCard: "0px 1px 12px 1px rgba(0, 0, 0, 0.08)", // X, Y, Blur, Spread
  dashBoardCard: "0px 1px 12px 1px rgba(0, 0, 0, 0.08)",
};

export const CHART_COLOR = [
  "#E77C7A",
  "#6AABD2",
  "#A3D977",
  "#F4D35E",
  "#EE964B",
  "#9C89B8",
  "#C92A2A",
  "#FF6B6B",
  "#48CAE4",
  "#90BE6D",
  "#FFD166",
  "#F3722C",
  "#6930C3",
  "#FF9F1C",
  "#D00000",
  "#74C69D",
  "#00B4D8",
  "#A663CC",
  "#E63946",
  "#2A9D8F",
  "#F77F00",
  "#8338EC",
  "#EF476F",
  "#06D6A0",
  "#118AB2",
  "#F94144",
  "#577590",
  "#8D99AE",
  "#FF477E",
  "#4ECDC4",
];
